import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Injectable, Injector, Input, OnChanges, ViewEncapsulation, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Entity, QuotePolicy } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import * as Enumerable from 'linq';
import { map, Observable, of } from 'rxjs';

@Component({
  selector: 'quote-policy-picker',
  templateUrl: './quote.policy.picker.component.html',
  styleUrls: ['./quote.policy.picker.component.less'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule
  ],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => QuotePolicyPickerComponent), multi: true }
  ],
})
export class QuotePolicyPickerComponent extends PickerBaseComponent implements OnChanges {

  @Input() public data: Entity[];
  @Input() public placeholder = '<Quote Policy>';
  @Input() public appendTo: any;
  @Input() public multiple: boolean;
  @Input() public clearable: boolean;

  public data$: Observable<Entity[]>;
  public PickerItemStyle = PickerItemStyle;

  constructor(
    injector: Injector,
    private policies: QuotePolicyPickerService
  ) {
    super(injector);
    this.fetch = PickerFetch.Automatic;
  }

  public ngOnChanges() {

    this.data$ = this.fetch === PickerFetch.Automatic
      ? this.policies.getPolices()
      : of(this.data);

  }
}

@Injectable({ providedIn: 'root' })
export class QuotePolicyPickerService {

  constructor(
    private http: HttpClient
  ) { }

  public getPolices(): Observable<Entity[]> {
    return this.http.get<Entity[]>(`/api/picker/policies/quote`)
      .pipe(
        map(x => {
          return Enumerable
            .from(x)
            .orderBy(x => x.name)
            .toArray();
        })
      );
  }

  public getPolicy(id: string): Observable<QuotePolicy> {
    return this.http.get<QuotePolicy>(`/api/picker/policies/quote/${id}`);
  }

  public getDefaultPolicy(): Observable<QuotePolicy> {
    return this.http.get<QuotePolicy>(`/api/picker/policies/quote/default`);
  }

}

